<template>
  <div class="main main--hasHeader main--hasFooter">
    <div class="customContainer">
      <div class="row">
        <h2 class="members__headline">チェックイン</h2>
        <div class="members-checkin">
          <div class="members-checkin__list">
            <div class="members-checkin__list-inner d-flex align-items-center">
              <div class="item">
                <p>チェックイン日時</p>
              </div>
              <div class="name">
                <p>{{ checkin.checkin_date_label }}</p>
              </div>
            </div>
            <div class="members-checkin__list-inner d-flex align-items-center">
              <div class="item">
                <p>ご利用人数</p>
              </div>
              <div class="name">
                <p>{{ (parseInt(checkin.companion_num) + 1) }}名</p>
              </div>
            </div>
            <!-- {{ reservation_node_extract({type: 'drive'}) }} -->
            <div class="members-checkin__list-inner d-flex align-items-center"
              v-if="typeof reservation_node_extract({stat: 1}) === 'object' && Object.keys(reservation_node_extract({stat: 1})).length > 0"
            >
              <div class="item">
                <p>ご利用予定</p>
              </div>
              <div class="name">
                <div v-if="typeof reservation_node_extract({type: 'drive', stat: 1}) === 'object' && Object.keys(reservation_node_extract({type: 'drive', stat: 1})).length > 0">
                  <span class="icon01">走行</span>
                  <div v-for="node in reservation_node_extract({type: 'drive', stat: 1})" :key="node">
                    <div v-if="typeof node.item_data === 'object' && Object.keys(node.item_data).length > 0">
                      <p v-for="item in node.item_data" :key="item">
                        {{ item.label }} / {{ item.start_time_str }}-{{ item.end_time_str }}
                      </p>
                    </div>
                  </div>
                </div>
                <div v-if="typeof reservation_node_extract({type: 'lodge', stat: 1}) === 'object' && Object.keys(reservation_node_extract({type: 'lodge', stat: 1})).length > 0">
                  <span class="icon02">宿泊</span>
                  <div v-for="node in reservation_node_extract({type: 'lodge', stat: 1})" :key="node">
                    <p>{{ node.category_group_label }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="members-checkin__list-inner d-flex align-items-center"
              v-if="typeof reservation_node_extract({stat: 10}) === 'object' && Object.keys(reservation_node_extract({stat: 10})).length > 0"
            >
              <div class="item">
                <p>ご利用</p>
              </div>
              <div class="name">
                <div v-if="typeof reservation_node_extract({type: 'drive', stat: 10}) === 'object' && Object.keys(reservation_node_extract({type: 'drive', stat: 10})).length > 0">
                  <span class="icon01">走行</span>
                  <div v-for="node in reservation_node_extract({type: 'drive', stat: 1})" :key="node">
                    <div v-if="typeof node.item_data === 'object' && Object.keys(node.item_data).length > 0">
                      <p v-for="item in node.item_data" :key="item">
                        {{ item.label }} / {{ item.start_time_str }}-{{ item.end_time_str }}
                      </p>
                    </div>
                  </div>
                </div>
                <div v-if="typeof reservation_node_extract({type: 'lodge', stat: 10}) === 'object' && Object.keys(reservation_node_extract({type: 'lodge', stat: 10})).length > 0">
                  <span class="icon02">宿泊</span>
                  <div v-for="node in reservation_node_extract({type: 'lodge', stat: 1})" :key="node">
                    <p>{{ node.category_group_label }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="members-checkin__usage">
            <p class="members-checkin__head">ご利用履歴</p>
              <ul class="members-checkin__usage-inner"
                v-for="sale in sales_list" :key="sale"
              >
                <li class="item d-flex align-items-center">
                  <p>
                    {{ sale.sale_date_label }} {{ sale.sale_time_label }}
                    <span v-if="getDepartmentLabel(sale.department_id)">
                      / {{ getDepartmentLabel(sale.department_id) }}
                    </span>
                    <span v-if="sale.use_checkin_guest_id > 0">
                      / ゲスト
                    </span>
                    <span v-else>
                      / 会員
                    </span>
                  </p>
                  <span class="price">
                    ¥{{ sale.selling_price }}<br>
                    <a @click="saleDetailToggle(sale)" v-if="sale.detail_disp_sw">-閉じる</a>
                    <a @click="saleDetailToggle(sale)" v-else>+内訳</a>
                  </span>
                </li>
                <section v-if="sale.detail_disp_sw">
                  <li class="item d-flex align-items-center" v-for="article in sale.article_list" :key="article">
                    <p>{{ article.article_label }}</p>
                    <span class="price">¥{{ article.row_price}}</span>
                  </li>
                </section>
              </ul>
            </div>
        </div>
      </div>
    </div>
  </div>



</template>
<script>
import { mapState } from 'vuex'
import config from '../../../const'
import axios from 'axios'
import Common from '../../../common/common'
// import BsPageTitle from '../../molecules/BsPageTitle.vue'
// import CardView from './CardView.vue'

// import BsSelect from '../../atoms/BsSelect.vue'
// import BsCheckBox from '../../atoms/BsCheckBox.vue'
// import '../../assets/bootstrap/css/sc.css';

export default {
  name: 'UserCheckinView',
  data: function () {
    return {
      checkin: {},
      sales_list: [],
      reservation_node: [],
    }
  },
  components: {
      // BsPageTitle,
        // CardView,
    //   BsSelect,
      // BsCheckBox,
  },
  methods: {
    saleDetailToggle(sale){
      if(sale && sale.detail_disp_sw){
        sale.detail_disp_sw = false;
      }
      else if(sale && sale.detail_disp_sw == false){
        sale.detail_disp_sw = true;
      }
    },
    // データ取得系
    loadData(target_c, params){
      return this.$store.dispatch('fetchBasicLists', {data: params, target: target_c})
        .catch(err => Promise.reject(err))
        .then(() => {})
        .finally(() => {
          this.$forceUpdate();
        })
    },
    // login御
    loadUser(){
      const params = {};
      params['id'] = this.$store.state.auth.userId;
      console.log('params', params);
      return this.$store.dispatch('fetchBasicLists', {data: params, target: 'user', targetF: 'get'})
      .catch((err) => {
        console.log(err);
        Promise.reject(err)
      })
      .then(() => {})
      .finally(() => {});
    },
    loadReservation(){
      const params = {};
      params['use_m_id'] = this.getMyData.id;
      // checkinと紐ついていないもの
      params['checkin_id'] = this.checkin.id;
      // // 予約だけでチェックインはしていない
      params['stat'] = [1, 10];
      console.log('loadSales params', params);
      const params_ = Common.createParams(params);
      axios.post(
          config.BASE_API_URL + '/reservation_node/lists',
          params_,
          {
          headers: this.axiosHeader
          }
      )
      .then(
          (response) => {
            if(response.data.body){
              this.reservation_node = response.data.body;
            }else{
              this.reservation_node = [];
            }
          }
      )
      .catch((err) => {
          console.log(err);
          this.reservation_node = [];
      })
      .finally(() => {
          this.$forceUpdate();
      })

    },
    loadSales() {
      const params = {};
      params['user_id'] = this.getMyData.id;
      // checkinと紐ついていないもの
      params['checkin_id'] = this.checkin.id;
      // // 予約だけでチェックインはしていない
      params['stat'] = [1, 10];
      console.log('loadSales params', params);
      const params_ = Common.createParams(params);
      axios.post(
          config.BASE_API_URL + '/sales/lists',
          params_,
          {
          headers: this.axiosHeader
          }
      )
      .then(
          (response) => {
      // console.log('loadSales response', response);
            this.sales_list = response.data.body.map(sale => {
              sale.detail_disp_sw = false;
              return sale;
            });
            // this.sales_list = response.data.body;
          }
      )
      .catch((err) => {
          console.log(err);
          this.sales_list = [];
      })
      .finally(() => {
          this.$forceUpdate();
      })
    },
  },
  computed: {
    ...mapState({
      user: state => state.apidata.user,
      department: state => state.apidata.department,
    }),
    getMyData: function(){
      const mydata = this.user.find((data) => {
        return data.id == this.$store.state.auth.userId;
      })
      return mydata;
    },
    getDepartment: function(){
      const department = this.department;
      return function(target){
        return department.find(dep => {
          return (dep.id == target)
        })
      }
    },
    getDepartmentLabel: function(){
      const department = this.department;
      return function(target){
        // const department = this.getDepartment(target);
        const dep = department.find(dep => {
          return (dep.id == target)
        });
        console.log('getDepartmentLabel dep', dep);
        if(dep && dep.label){
          return dep.label;
        }else{
          return '';
        }
      }
    },
    reservation_node_extract(){
      const node = this.reservation_node;
      return function(cond){
        if(typeof node !== 'object' || (typeof node === 'object' && Object.keys(node).length <= 0)){
          return [];
        }
        const tmp = node.filter(reservation => {
          let flg = false;
          if(typeof cond === 'object'){
            let cnt = 0;
            Object.keys(cond).forEach(index => {
              if(
                reservation[index] && reservation[index] == cond[index]
              ){
                cnt++;
              }
            });
            if(cnt == Object.keys(cond).length){
              flg = true;
            }
          }
          return flg;
        });
        // console.log('reservation_node_extract', cond, tmp);
        return tmp;
      }
    },
    axiosHeader: function(){
        return {[config.BASE_API_HEADER_KEY]: this.$store.state.auth.token};
    },
  },
  created () {
    const basicParams = {};
    basicParams['stat'] = [1];
    this.loadData('department', basicParams)

    this.loadUser();
    this.checkin = this.getMyData.checkin;
    this.loadSales();
    this.loadReservation();
  },
  mounted: function(){
      // console.log('checkin mounted', this.checkin);
    if(
      !this.checkin
      || typeof this.checkin !== 'object'
    ){
      this.$router.push({ path: '/' });
    }
  },

}
</script>
